import { useAppContext } from "../context/appContext";

import { Navigate } from "react-router";

const ProtectedRoute = ({ children }) => {
  const { user } = useAppContext();

  if (!user?.email) {
    return <Navigate to="/" />;
  }
  return children;
};

export default ProtectedRoute;
